import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SectionHeadingProps {
  children: ReactNode;
  /** Deeper level when the heading is nested under another. */
  as?: 'h2' | 'h3' | 'h4';
  /** Off inside a bordered card, whose own edge already separates the content. */
  rule?: boolean;
  /** `sm` sits under a dialog's 18px title instead of matching it. */
  size?: 'md' | 'sm';
  className?: string;
}

const SIZE_CLASSES = { md: 'text-lg', sm: 'text-nav' } as const;

/**
 * An Inter section heading, optionally over a hairline. Distinct from the kit's
 * `SectionTitle`, which is Kapra above a bordered `SectionCard`.
 */
export function SectionHeading({
  children,
  as: Tag = 'h2',
  rule = true,
  size = 'md',
  className,
}: SectionHeadingProps) {
  return (
    <div className={cn(rule && 'mb-8', className)}>
      {/* Size first: tailwind-merge drops a leading-* that comes before a text-* size. */}
      <Tag className={cn(SIZE_CLASSES[size], 'font-inter font-semibold leading-normal text-off-black')}>
        {children}
      </Tag>
      {rule && <div className="mt-4 h-px w-full bg-dinnerplate-white" />}
    </div>
  );
}
